import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getUsageReports($businessId: ID!, $topics: [String], $interval: String) {
    usageReports(businessId: $businessId, topics: $topics, interval: $interval) {
      reports {
        label
        topic
        description
        points {
          date
          value
        }
      }
    }
  }
`

export const usageReportsKey = getQueryNames(query)[0]

export default query
